import { render, staticRenderFns } from "./new_proposal.vue?vue&type=template&id=331c48ae&scoped=true"
import script from "./new_proposal.vue?vue&type=script&lang=js"
export * from "./new_proposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c48ae",
  null
  
)

export default component.exports